import { render, staticRenderFns } from "./bindPhoneOnely.vue?vue&type=template&id=b5d36116&"
import script from "./bindPhoneOnely.vue?vue&type=script&lang=js&"
export * from "./bindPhoneOnely.vue?vue&type=script&lang=js&"
import style0 from "./bindPhoneOnely.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports